module.exports = __webpack_public_path__ + "static/img/other-tuwenti.bb4cc12a.png";